import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How is coaching different from therapy?",
    a: "Coaching is forward-focused, action-based, and about building skills and routines to reach goals. Therapy focuses on healing past pain, emotional processing, and clinical treatment. I'll assess whether coaching fits your needs or if a therapy referral is preferred. I validate negative emotions, but we don't dwell on them. Instead we pull out the positive ones and empower you to build on the good.",
  },
  {
    q: "How much will this cost, and does insurance cover it?",
    a: "Cost varies by package; common rates are per session or as monthly packages. Most insurance doesn't cover coaching, but some employers or HSA/FSA plans may. I'll assess your needs and give you clear pricing up front during your free consultation.",
  },
  {
    q: "How long does a coach work with a client?",
    a: "Coaching has an agreed end. Some people finish after about 5 sessions, many build habits in 3–6 months, and others keep monthly check-ins. We'll assess your needs, set a timeline together, and decide when to finish or continue.",
  },
  {
    q: "Can you fix my [insert ADHD trait here]?",
    a: "You're not broken and don't need fixing. But we will work together to assess patterns, define a clear target, co-create practical strategies, carry them out together, and assess progress.",
  },
  {
    q: "Can you guarantee results?",
    a: "Only you can determine the results. The hard work comes from you! My job is to bring structure, strategy, and steady partnership; your job is to bring the goals, spark, and willingness to try.",
  },
  {
    q: "Do I need a formal ADHD diagnosis to work with you?",
    a: "Not at all. Many clients are exploring, suspect ADHD, or were recently diagnosed. We start where you are.",
  },
  {
    q: "Who do you work with?",
    a: "Adults and college students with ADHD, parents of neurodiverse children, and groups of parents or educators looking for ADHD-friendly strategies.",
  },
  {
    q: "How do I get started?",
    a: "The easiest way is to book a free discovery call. We'll talk about what's going on and whether coaching feels like the right fit.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-white/40"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="text-center reveal">
          <span className="text-xs md:text-sm uppercase tracking-[0.28em] text-brand-coral font-semibold">
            Frequently asked
          </span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl lg:text-6xl text-brand-navy leading-[1.05] tracking-tight">
            Questions, answered.
          </h2>
        </div>

        <div className="mt-14 reveal">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-brand-sage/20"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="text-left font-serif text-xl md:text-2xl text-brand-navy hover:text-brand-coral hover:no-underline py-6"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="text-base md:text-lg leading-relaxed text-brand-navy/75 pb-6"
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
